var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"w-10 h-10 border-8 border-blue rounded-full loader",style:({borderColor: _vm.theme.primaryColor, borderRightColor: 'transparent'})})
}
var staticRenderFns = []

export { render, staticRenderFns }